<script>
import BaseLisitng from '../../../share/ListingWithEditMode'
import clientObjectMixin from '../../share/mixins/clientObjectMixin'

export default {
  mixins: [
    BaseLisitng,
    clientObjectMixin
  ],
  data () {
    return {
      service: this.$route.params.service,
      headerTitle: { title: 'Stany procesu', description: 'Lista' },
      editModeUrlName: '',
      gridDataSource: null,
      gridName: 'grid_state',
      editEventName: ''
    }
  },
  computed: {
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: () => { return '' }
        },
        { id: 1, data: 'label', title: 'Opis' },
        { id: 2, data: 'name', title: 'Nazwa' },
        { id: 3, data: 'initial', title: 'Stan początkowy', searchable: false },
        { id: 4, data: 'final', title: 'Stan końcowy', searchable: false },
        { id: 5, data: 'roles', title: 'Role odpowiedzialego', searchable: false, sortable: false }
      ]
    }
  },
  created () {
    this.getInitEditModeUrlName()
    this.getInitEditEventName()
    this.getInitGridDataSource()
  },
  methods: {
    getInitEditModeUrlName () {
      this.editModeUrlName = `${this.service}_state_edit`
    },
    getInitEditEventName () {
      this.editEventName = `${this.service}:main:addState`
    },
    getInitGridDataSource () {
      this.gridDataSource = { service: this.service, url: `/workflows/${this.$getCategoryNew(this.clientObject, this.$route.params.taskCategoryId).workflows[0].id}/states` }
    }
  }
}
</script>
